import { Link } from "react-router-dom";
import Logo from "@/components/common/Logo";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { Menu } from "lucide-react";
import { useSafeAreaInsets } from "@/hooks/useSafeAreaInsets";
import { cn } from "@/lib/utils";
const ValuationHeader = () => {
  const { topPadding } = useSafeAreaInsets();
  return <header className={cn("border-b border-gray-800 py-4 px-4 bg-godyspo-background", topPadding)}>
      <div className="container mx-auto flex justify-between items-center">
        <Link to="/consumer" aria-label="Go to consumer page">
          <Logo className="text-[#ffd700]" disableLink />
        </Link>
        
        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center gap-6">
          <Link to="/consumer" className="text-gray-300 hover:text-[#ffd700] transition-colors">Home</Link>
          <Link to="/blog" className="text-gray-300 hover:text-[#ffd700] transition-colors">Blog</Link>
          <Link to="/contact" className="text-gray-300 hover:text-[#ffd700] transition-colors">
            Contact
          </Link>
        </nav>

        {/* Mobile Dropdown Menu */}
        <div className="md:hidden">
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button className="bg-[#ffd700] text-[#080c14] hover:bg-[#e6c200]">
                <Menu className="h-5 w-5" />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent className="w-48 bg-[#080c14] border-gray-800 z-50" align="end">
              <DropdownMenuItem asChild>
                <Link to="/consumer" className="text-gray-300 hover:text-[#ffd700] hover:bg-gray-800 cursor-pointer">
                  For Homeowners
                </Link>
              </DropdownMenuItem>
              <DropdownMenuItem asChild>
                <Link to="/blog" className="text-gray-300 hover:text-[#ffd700] hover:bg-gray-800 cursor-pointer">
                  Blog
                </Link>
              </DropdownMenuItem>
              <DropdownMenuSeparator className="bg-gray-800" />
              <DropdownMenuItem asChild>
                <Link to="/contact" className="text-gray-300 hover:text-[#ffd700] hover:bg-gray-800 cursor-pointer">
                  Contact
                </Link>
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      </div>
    </header>;
};
export default ValuationHeader;